import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom"; // Import withRouter
import ConfirmApprovedModel from "./ConfirmApprovedModel";
import ConfirmRejectModel from "./ConfirmRejectModel";
const token = localStorage.getItem('authToken');
class EditBloodBank extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            textInput: "",
            userName: "",
            name: "",
            category: "",
            areaInput: "",
            categoryData: [],
            city: "",
            contactNo: '',
            pincode:"",
            iscontactNoValid: true,
            ispincodeValid: true,
            submissionStatus: null,
            currentImageUrl: null,
            submeet: false,
            errors: [],
            maxSize: 5 * 1024 * 1024, // 5MB in bytes
        };
    }

    async componentDidMount() {
        const { match } = this.props;
        if (match && match.params && match.params.id) {
            const { id } = match.params;
            this.setState({ id });
            await this.userData(id);
        } else {
            console.error("No match params found.");
        }
        
    }

    userData = async (id) => {
        try {
            const response = await axios.get(`https://samaj.aasmo.in/api/admin/bloodBank/${id}`, {
                headers: {
                  Authorization: `Bearer ${token}`, 
                },
              });
            console.log(response.data)
            if (response) {
                this.setState({
                    name:response.data.name,
                    contactNo:response.data.contactNo,
                    areaInput:response.data.address,
                    pincode:response.data.pincode
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


  handleSubmit = async (e) => {
        e.preventDefault();

        this.setState({ submeet: true });

        const {areaInput , name,contactNo ,pincode} = this.state;
        const { id } = this.props.match.params;

        try {
            const data = {
                name:name,
                address: areaInput,
                contactNo:contactNo,
                pincode:pincode,
            };
           

            const response = await axios.put(`https://samaj.aasmo.in/api/admin/bloodBank/${id}`, data, {
                headers: {
                    'Content-Type': 'application/json',
                   
                          Authorization: `Bearer ${token}`, 
                     
                },
            });
            if (response.status === 200) {
                this.setState({ submissionStatus: 'success', submeet: false });
                setTimeout(() => {
                    this.props.history.push( "/bloodbank");
                }, 2000);
            }
        } catch (error) {
            console.log(error);
            this.setState({ submissionStatus: 'error' });
        }
    };

    render() {
        const { textInput, iscontactNoValid, contactNo, name,ispincodeValid, pincode, currentImageUrl, city, userName, category, categoryData, submeet, areaInput, submissionStatus } = this.state;
        const isNameValid = userName.trim().length > 0;
        const isnameValid = name.trim().length > 0;
        const isCityValid = city?.trim().length > 0;

        return (
            <div className="col-md-12">
                <div className="card">
                    <div className="header">
                        <h2>Edit Blood Bank Details</h2>
                    </div>
                    <div className="body">
                        <form onSubmit={this.handleSubmit}>
                            <div className="form-group">
                                <label>Name</label>
                                <input
                                    className={`form-control ${!isnameValid && submeet && "parsley-error"}`}
                                    value={name}
                                    name="name"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ name: e.target.value });
                                    }}
                                />
                                {!isnameValid && submeet ? (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>Contact No</label>
                                <input
                                    className={`form-control ${!iscontactNoValid && submeet && "parsley-error"}`}
                                    value={contactNo}
                                    name="contactNo"
                                    required=""
                                    type="number"
                                    onChange={(e) => {
                                        this.setState({ contactNo: e.target.value });
                                    }}
                                />
                                {!iscontactNoValid && submeet ? (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <label>Address</label>
                                <textarea
                                    className={`form-control ${areaInput === "" && submeet && "parsley-error"
                                        }`}
                                    value={areaInput}
                                    cols="30"
                                    name="textarea"
                                    required=""
                                    rows="5"
                                    onChange={(e) => {
                                        this.setState({ areaInput: e.target.value });
                                    }}
                                ></textarea>
                                {areaInput === "" && submeet ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <label>Pincode</label>
                                <input
                                    className={`form-control ${!ispincodeValid && submeet && "parsley-error"}`}
                                    value={pincode}
                                    name="pincode"
                                    required=""
                                    type="number"
                                    onChange={(e) => {
                                        this.setState({ pincode: e.target.value });
                                    }}
                                />
                                {!ispincodeValid && submeet ? (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>

                            {submissionStatus === 'success' && (
                                <div className="alert alert-success" role="alert">
                                    Form submitted successfully!
                                </div>
                            )}

                            <button className="btn btn-primary" type="submit">
                                Submit
                            </button>
                        </form>
                    </div>
                </div>
               
            </div>
        );
    }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, { notifyGeneralInfo })(withRouter(EditBloodBank)); // Wrap with withRouter
